export class NotificationSetting {
  /**
   * Required. Bundle identifier of app to which to apply these notification settings.
   */
  bundleIdentifier: string;

  /**
   * Optional. Whether notifications are allowed for this app. Default is true.
   */
  notificationsEnabled?: boolean;

  /**
   * Optional. Whether notifications can be shown in notification center. Default is true.
   */
  showInNotificationCenter?: boolean;

  /**
   * Optional. Whether notifications can be shown in the lock screen. Default is true.
   */
  showInLockScreen?: boolean;

  /**
   * Optional. The type of alert for notifications for this app:
   * 0: None
   * 1: Banner
   * 2: Modal Alert
   * Default is 1.
   */
  alertType?: number;

  /**
   * Optional. Whether badges are allowed for this app. Default is true.
   */
  badgesEnabled?: boolean;

  /**
   * Optional. Whether sounds are allowed for this app. Default is true.
   */
  soundsEnabled?: boolean;

  /**
   * Optional. Whether notifications can be shown in CarPlay. Default is true.
   * Availability: Available in iOS 12 and later.
   */
  showInCarPlay?: boolean;

  /**
   * Optional. Whether an app can mark a notification as a critical notification that will ignore Do Not Disturb and ringer settings.
   * Default is false.
   * Availability: Available in iOS 12 and later.
   */
  criticalAlertEnabled?: boolean;
}
